export const SET_PENDING = 'SET_PENDING'
export const SET_NO_CREDITS_FOR_CLASSIFIED = 'SET_NO_CREDITS_FOR_CLASSIFIED'
